export const handleLogout = () => {
  localStorage.removeItem("root");
};
